"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListModel_1 = require("@twii/core/lib/model/ListModel");
var TabLayout = require("@twii/bored/lib/model/TabLayout");
var TwoColumnLayout = require("@twii/bored/lib/model/TwoColumnLayout");
var ThreeColumnLayout = require("@twii/bored/lib/model/ThreeColumnLayout");
var GridLayout = require("@twii/bored/lib/model/GridLayout");
// the dashboard layout register - initialized with defaults
var DashboardLayoutRegistry = new ListModel_1.ListModel([
    {
        key: "tabs",
        name: "Tabs",
        iconProps: { iconName: "BrowserTab" },
        applyLayout: TabLayout.applyLayout,
        isLayoutApplied: TabLayout.isLayoutApplied
    },
    {
        key: "2cols",
        name: "Two Columns",
        iconProps: { iconName: "DoubleColumn" },
        applyLayout: TwoColumnLayout.applyLayout,
        isLayoutApplied: TwoColumnLayout.isLayoutApplied
    },
    {
        key: "3cols",
        name: "Three Columns",
        iconProps: { iconName: "TripleColumn" },
        applyLayout: ThreeColumnLayout.applyLayout,
        isLayoutApplied: ThreeColumnLayout.isLayoutApplied
    },
    {
        key: "grid",
        name: "Grid",
        iconProps: { iconName: "LargeGrid" },
        applyLayout: GridLayout.applyLayout,
        isLayoutApplied: GridLayout.isLayoutApplied
    }
]);
exports.DashboardLayoutRegistry = DashboardLayoutRegistry;
